import "./index.css";
import SvgTracer from "./pages/SvgAnimator";

export function App() {
  return (
    <>
      <SvgTracer />
    </>
  );
}

export default App;
